const Urls = {
	Api: {
		product: '/my/api/2/wishlist'
	},
	Templates: {
		app: '/my/api/2/templates?name=modules/add-to-wishlist/app.html'
	}
};

export default Urls;